import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FooterSponsorsComponent } from '../footer-sponsors/footer-sponsors.component';

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [RouterModule, FooterSponsorsComponent],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {

}
